import * as actionTypes from "../actions";
const initialState = {};

export function categoriesReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_CATEGORIES:
      return (state = action.payload);
    default:
      return state;
  }
}
export default categoriesReducer;
